import React from 'react';
import styled from 'styled-components';
import BREAK_POINTS from '../../styling/media-queries';

const s = {
  Container: styled.div`
    color: #ffffff;
    background: #000000;
    padding: 20px;

    @media ${BREAK_POINTS.tablet} {
      flex-direction: column;
      border-bottom: 1px solid #1b1b1b;
      margin-bottom: 30px;
    }
  `,
  Header: styled.h1`
    font-size: 1.375em;
    font-weight: bold;

    @media ${BREAK_POINTS.desktop} {
      font-size: 1.5em;
    }
  `,
};

export type TitleProps = {
  header: string;
  subHeader?: string;
  className?: string;
};

const Title = ({ header, subHeader, className }: TitleProps) => (
  <s.Container className={className}>
    <s.Header>{header}</s.Header>
    {subHeader && <p>{subHeader}</p>}
  </s.Container>
);

export default Title;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/fees-and-deductibles/Title.tsx